import { Serie } from "@nivo/line";
import { RollingSystemFrequencyModel } from "models/rollingSystemFrequency/rollingSystemFrequencyModel";
import { chartColours } from "styles/colours";
import { sortByMeasurementTime } from "utils/ChartDataUtils/index";

export const transformRollingSystemFrequencyModelData = (
  rawData: RollingSystemFrequencyModel[]
): Serie[] => {
  const sortedData = sortByMeasurementTime(rawData);

  const data = sortedData
    .filter((curr) => curr.frequency !== 0)
    .map((curr) => ({
      x: new Date(curr.measurementTime),
      y: curr.frequency,
    }));

  return [
    {
      id: "frequency",
      colour: chartColours.frequencyData,
      data,
    },
  ];
};
